import img from 'Images/defaultLogo.svg';
import { Organization } from 'Models';

// eslint-disable-next-line import/prefer-default-export
export const useGetCompanyLogo = (
  organization: Organization | undefined | null
) => organization?.logoUrl ?? img;
